
import axios from 'axios'

export default (endpoint, data = {}) => axios.post(
  Array.isArray(endpoint) ? `${endpoint[0]}/${endpoint[1]}` : endpoint,
  data,
  {
    baseURL: '/api/',
    headers: { 'X-Tenant-Token': $vm.$store.state.token }
  }
)
